module.exports = __webpack_public_path__ + "06911ae3adbc99d4cb0ea7bb531d5222.jpg";